import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className?: string;
  children?: React.ReactNode;
}

export const TitleBox = styled.div`
  padding-top: 4px;

  .title {
    font-size: 16px;
    font-weight: 500;
    line-height: 130%;
  }

  .sub-title {
    display: block;
    margin-top: 4px;
    font-size: 13px;
    line-height: 130%;
    color: #999;
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding-top: ${mixin.pxToVw('4')};

    .title {
      font-size: ${mixin.pxToVw('16')};
    }

    .sub-title {
      margin-top: ${mixin.pxToVw('4')};
      font-size: ${mixin.pxToVw('13')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .title {
      font-size: 17px;
    }

    .sub-title {
      font-size: 14px;
    }
  }
`;

export const InputBox = styled.div<IProps>`
  ${mixin.flex({ justify: 'flex-start' })};
  column-gap: 6px;
  margin-top: 20px;

  .between,
  .over {
    display: inline-block;
    flex: none;
    width: 11px;
    height: 21px;
    line-height: 130%;
    text-align: center;
    position: relative;

    &.over {
      opacity: 0;
    }
  }

  &.isOver {
    .over {
      opacity: 1;
    }
  }

  .input {
    border: 1px solid #e2e2e2;

    input {
      height: 40px;
      padding: 0 8px 0 10px;
      border: 0;
      width: 100%;
      font-size: 14px;
      line-height: 130%;
    }

    .inp-suffix {
      font-size: 14px;
      line-height: 130%;
      padding-right: 10px;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    column-gap: ${mixin.pxToVw('6')};
    margin-top: ${mixin.pxToVw('20')};

    .between,
    .over {
      width: ${mixin.pxToVw('11')};
      height: ${mixin.pxToVw('21')};
    }

    .input {
      input {
        height: ${mixin.pxToVw('40')};
        padding: ${mixin.pxToVw('0 8 0 10')};
        font-size: ${mixin.pxToVw('14')};
      }

      .inp-suffix {
        font-size: ${mixin.pxToVw('14')};
        padding-right: ${mixin.pxToVw('10')};
      }
    }
  }
`;

export const SliderBox = styled.div`
  padding: 0 8px;
  margin-top: 35px;

  .slider {
    position: relative;
  }

  .rail {
    position: absolute;
    width: calc(100% + 16px);
    left: -8px;
    height: 2px;
    border-radius: 2px;
    cursor: pointer;
    background-color: #e2e2e2;
    z-index: 0;
  }

  .handle {
    &::before {
      content: '';
      display: block;
      width: 50px;
      height: 50px;
      border-radius: 100%;
      background-color: transparent;
      position: absolute;
      z-index: 1;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    margin-top: ${mixin.pxToVw('35')};

    .handle {
      &::before {
        width: ${mixin.pxToVw('50')};
        height: ${mixin.pxToVw('50')};
      }
    }
  }
`;
